import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { TravelerComponent } from "../../virtualTraveler/TravelerComponent";
import { RSDVirtualTravelerComponent } from "./RSDVirtualTravelerComponent";
import { TravelerMasterContainer } from "../../../../common/traveler/TravelerMasterContainer";
import { TravelerMasterRow } from "../../../../common/traveler/TravelerMasterRow";
import { TravelerNotesContainer } from "../../../../common/traveler/TravelerNotesContainer";
import { TravelerGroupHeader } from "../../../../common/traveler/TravelerGroupHeader";
import { Grid, MenuItem, TextField } from "@material-ui/core";
import { TravelerContainer } from "../../../../common/traveler/TravelerContainer";
import { useAssignRSD } from "../../../../dataEgress/dataEgressMutations";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../../common/FetchContext";
import { useQueryClient } from "react-query";
import { report } from "process";
import { useProcedureNameResult } from "../../../../testCommunication/common/testQueries";


export const RsdVirtualTraveler = ({ serialNumber,report_data, travelerOpen, handleTraveler }: any) => {
  //   const [travelerOpen, setTravelerOpen] = React.useState(false);

  //   const handleTraveler = () => {
  //     setTravelerOpen(!travelerOpen);
  //   };
  const queryClient = useQueryClient()
  const { mutateAsync: mutateRsd } = useAssignRSD();
  const [selectedProcedure, setSelectedProcedure] = useState("");
  const { authAxios } = useFetchContext();  
  const updateReportResult = async (reportSequence: string, procedure_execution_order:any) => {  
    
    try {
                  
       await mutateRsd({
        authAxios,
        serial_number: serialNumber,
        report_result_id:report_data.Id,
        data_ready_status:reportSequence,
        procedure_execution_order,
        is_procedure: true
      });

      toast.success("Report was succesfully changed");
      setSelectedProcedure(reportSequence)
      // travelerOpen = true;
      // handleTraveler();
    } catch (error) {
      toast.error(`Error updating: ${error}`);
    }finally{
      queryClient.invalidateQueries(["report_result_data", report_data.work_order_id]);

    }
  }
  const {
    error: errorUnits,
    data: reportSequenceData,
    isError: isErrorUnits,
    isSuccess: isSuccessUnits,
    isLoading: isLoadingUnits,
  } = useProcedureNameResult(serialNumber);

  return (
    <div>
      <Dialog
        open={travelerOpen}
        onClose={() => handleTraveler()}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="scroll-dialog-title">
          Traveler: {serialNumber}
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={3}
            >

              <TextField
                id="report_sequence"
                label="Report sequence"
                name="report_sequence_select"
                disabled={false}
                select
                fullWidth
                variant="outlined"
                size="small"

              >
                {reportSequenceData?.map((rsd: any) => (
                  <MenuItem

                    key={rsd.name}
                    onClick={() =>
                      updateReportResult(rsd.name, rsd.procedure_execution_order)
                      
                    }
                    value={rsd.name}
                  >
                    {rsd.name}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>

          </Grid>
        </DialogTitle>
        <DialogContent dividers={true}>
          {travelerOpen && (
            <RSDVirtualTravelerComponent serialNumber={serialNumber.replace(/_.*/, '')} selectedProcedure={selectedProcedure} />
          )}


        </DialogContent>

        <DialogActions>
          <Button onClick={() => handleTraveler()} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};